import React, { useState } from 'react';
import { Card, Typography, Button, message, Space, Result } from 'antd';
import { MailOutlined, ReloadOutlined } from '@ant-design/icons';
import { useAppDispatch, useAppSelector } from '../../hooks/redux';
import { resendVerification, clearError } from '../../store/authSlice';
import { Link, useLocation } from 'react-router-dom';
import './AuthForms.scss';

const { Title, Text, Paragraph } = Typography;

const EmailVerificationNotice: React.FC = () => {
  const dispatch = useAppDispatch();
  const { isLoading, error } = useAppSelector(state => state.auth);
  const location = useLocation();
  const email = location.state?.email || '';
  const [resendLoading, setResendLoading] = useState(false);

  const handleResendVerification = async () => {
    if (!email) {
      message.error('Email address not found. Please sign up again.');
      return;
    }

    try {
      setResendLoading(true);
      const result = await dispatch(resendVerification(email)).unwrap();
      message.success(result.message || 'Verification email sent successfully!');
    } catch (err) {
      message.error(error || 'Failed to resend verification email');
      dispatch(clearError());
    } finally {
      setResendLoading(false);
    }
  };

  return (
    <div className="auth-container">
      <Card className="auth-card">
        <Result
          icon={<MailOutlined style={{ color: '#0576b7', fontSize: '64px' }} />}
          title="Check Your Email"
          subTitle={
            <Space direction="vertical" size="middle" className="w-100">
              <Paragraph style={{ fontSize: '16px', color: '#6b7280', marginBottom: 0 }}>
                We've sent a verification link to:
              </Paragraph>
              <Text strong style={{ fontSize: '18px', color: '#0576b7' }}>
                {email}
              </Text>
              <Paragraph style={{ fontSize: '14px', color: '#6b7280', marginBottom: 0 }}>
                Please click the link in the email to verify your account and complete your registration.
              </Paragraph>
            </Space>
          }
          extra={
            <Space direction="vertical" size="large" className="w-100">
              <Button
                type="default"
                icon={<ReloadOutlined />}
                loading={resendLoading}
                onClick={handleResendVerification}
                className="auth-button"
                style={{ 
                  height: '40px',
                  borderColor: '#0576b7',
                  color: '#0576b7'
                }}
              >
                Resend Verification Email
              </Button>
              
              <Space direction="vertical" align="center">
                <Text style={{ color: '#6b7280', fontSize: '14px' }}>
                  Already verified your email?
                </Text>
                <Link to="/login" className="auth-link">
                  Sign In to Your Account
                </Link>
              </Space>
            </Space>
          }
        />
      </Card>
    </div>
  );
};

export default EmailVerificationNotice;